import { Component, EventEmitter, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { SourcedItem, SourcingOutcomeInformation, VendorsList } from 'src/app/shared/models/app-models/SourcingOutcome.model';
import { StatusData } from '../rfq-summary.component';
import { MPMMSInformation } from 'src/app/shared/models/app-models/MPMMSInformation.model';
import { AlertType } from 'src/app/shared/components/alert/alert.component';
import { DropDownOptions } from 'src/app/shared/models/app-models';

@Component({
  selector: 'app-raise-po-dialog',
  templateUrl: './raise-po-dialog.component.html',
  styleUrls: ['./raise-po-dialog.component.scss']
})
export class RaisePoDialogComponent {
  destroy$: Subject<boolean> = new Subject<boolean>();
  readonly dialogRef = inject(MatDialogRef<RaisePoDialogComponent>);
  rfqItems: SourcedItem[] = [];
  mpMmsInformation: MPMMSInformation[] = []
  vendorList: VendorsList[] = [];
  statusData!: StatusData;
  selectedId: number | null = null;
  vendorNames: string[] = [];
  vendorError: boolean = false;
  raisedPOVendors: string[] = [];
  vendorListOptions:DropDownOptions[]=[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<{ rfqSummary: SourcingOutcomeInformation }>,
  ) {
    this.rfqItems = data.selectedRfqItems;
    this.statusData = data.statusData;
    this.mpMmsInformation = data.mpMmsInformation;
    this.raisedPOVendors = [...new Set(this.mpMmsInformation .map(item => item.VendorNumber))];

    this.store
      .select('rfqSummary')
      .pipe(takeUntil(this.destroy$))
      .subscribe((rfqSummary: SourcingOutcomeInformation) => {
        this.vendorList = rfqSummary.VendorsList.filter((vendor) => vendor.QuotationAttachment.length > 0);;
      });
  }

  ngOnInit() {
    console.log("Raise Dialog open", this.rfqItems)
    this.handledropdownOptions();
    
    let vendorNames: string[] = [];
    for (const item of this.rfqItems) {
      if (item.Vendor && item.Vendor !== "-" && item.Vendor.includes("<br>")) {
        vendorNames = item.Vendor.split('<br>')
        vendorNames.forEach(vendor => this.vendorNames.push(vendor));
      } else if (item.Vendor && item.Vendor !== "-") {
        this.vendorNames.push(item.Vendor);
      }
    }
    // console.log(this.statusData);
  }

  handledropdownOptions() {
    this.vendorListOptions = this.vendorList.map((vendor: VendorsList) => {
      const alreadyRaisedPO = this.raisedPOVendors.includes(vendor.VendorNumber);
      const vendorName = vendor.Name + (this.isDateExpired(vendor.QuoteExpiring) ? " (Quote Expired)" : "");
      const dropdownOption = {
        id: vendor.Id || '',
        value: vendorName,
        disabled: alreadyRaisedPO
      };
      return dropdownOption;
    });
    return this.vendorListOptions;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  handleClose() {
    this.dialogRef.close();
  }

  handleSubmit() {
    if (this.selectedId && this.vendorList.length > 0) {
      const selectedVendor = this.vendorList.find((vendor) => vendor.Id === this.selectedId);
      if (selectedVendor) {
        if (this.vendorNames.includes(selectedVendor.Name.trim())) {
          this.vendorError = true;
          console.log("Selected vendor already exists in the vendorNames list. PO cannot be raised.");
          return;
        } else {
          this.vendorError = false;
        }
      }
      this.dialogRef.close(selectedVendor);
    }
  }

  isDateExpired(dateToCheck: any): boolean {
    try {
      const currentDate = new Date();
      return new Date(dateToCheck) < currentDate;
    } catch (error) {
      console.warn("date check failed");
      return true;
    }
  }

  public get alertType(): typeof AlertType {
    return AlertType;
  }
  
}